import { Component, OnInit } from '@angular/core'
import { TranslationService } from '@emilfreydigital/transifex-angular'
import {
  KcDataService
} from '../../../kc-data.service'
import { KcInfoData, KcRealmData, KcClientData, KcMessage } from '../../../interfaces/kc-data.interface'

@Component({
  selector: 'customer-portal-app-revolution-info',
  templateUrl: './revolution-info.component.html'
})
export class RevolutionInfoComponent implements OnInit {
  infoData: KcInfoData

  constructor(
    private readonly kcDataService: KcDataService,
    private readonly transifexTranslationsService: TranslationService
  ) {}

  public realmData: KcRealmData
  public clientData: KcClientData
  public message: KcMessage

  ngOnInit(): void {
    this.realmData = this.kcDataService.getRealmData()
    this.clientData = this.kcDataService.getClientData()
    this.infoData = this.kcDataService.getViewData() as KcInfoData
    this.message = this.infoData.message
  }

  getTranslation(): string {
    let str = ''

    switch (this.message.summary) {
      case 'kc.emailExistsMessage':
        str = 'Email already exist'
        break
      case 'kc.alreadyLoggedIn':
        str = 'You are already logged in.'
        break
      case 'kc.verifyEmailMessage':
        str = 'You must verify your email address to activate the user account.'
        break
      case 'kc.usernameExistsMessage':
        str = 'Username already exists.'
        break
      case 'kc.updateProfileMessage':
        str = 'You must update your user account to activate the user account.'
        break
      case 'kc.updatePasswordTitle':
        str = 'Update password'
        break
      case 'kc.updatePasswordMessage':
        str = 'You must change your password to activate the user account.'
        break
      case 'kc.unsupportedNameIdFormatMessage':
        str = 'Unsupported NameID format.'
        break
      default:
        str = this.message.summary
    }

    return this.transifexTranslationsService.translate(str, {
      _key: 'customerPortal.' + this.message.summary,
      _tags: 'kc-forms, 3.1, notranslate'
    })
  }
}
